import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NbMenuService, NbTabComponent } from '@nebular/theme';
import { MenuGroup } from '../../dynamic-input-model';
import { LayoutEditorService } from '../layout-editor.service';

@Component({
  selector: 'ngx-layout-input',
  templateUrl: './layout-input.component.html',
  styleUrls: ['./layout-input.component.scss'],
})
export class LayoutInputComponent implements OnInit,OnChanges {
  @Input() data:any;
  defaultMenuTag:string; 
  topLevelMenuTag = "editLayoutMenu";
  defaultInputMenuItem:string;
  activeInputMenuItem:string;
  menuGroups:any;
  //selectedMenuItem = 
  menuItemTitle:string;

  

  constructor(private menuService:NbMenuService,
    private layoutEditorService:LayoutEditorService) { 
  }

  ngOnInit(): void {
    //console.log(this.data);
    this.menuGroups = this.data;
    //this.defaultMenuTag = this.menuGroups.indexOf("topLevelMenu").
    let topLevelMenu:MenuGroup = this.menuGroups["topLevelMenu"];
    if(topLevelMenu != undefined){
      this.defaultMenuTag = topLevelMenu.menuTag;
      this.defaultInputMenuItem = topLevelMenu.menuItems[0].title;
      this.activeInputMenuItem = this.defaultInputMenuItem;
    }
    this.menuService.onItemClick().subscribe(menuBag =>{
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        this.activeInputMenuItem = selectedItem.title;
      }
    })
    console.log(this.activeInputMenuItem);
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["data"]){
      console.log(this.data);
    }
  }

  tabChanged(e:NbTabComponent){
    if(e.tabTitle == "Sections"){
        
    }
  }


}
